import * as API from "@/store/actions/axios-api-instance";

export default async function getLicense({commit}) {
    try {
        commit('SET_LOADING', true)
        const license = await API.getLicense()
        // console.log('getLicense', license)
        if (license) {
            const {expired, key, type} = license
            commit('SET_LICENSE', {
                expired, key, type: `${type}`.toUpperCase()
            })
        }
        commit('SET_LOADING', false)
    } catch (e) {
        commit('SET_LOADING', false)
        commit('SET_ERROR', e.message)
        throw e
    }
}